// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var BeltHoles_Result = require("belt-holes/src/BeltHoles_Result.bs.js");
var Tabtest$XodTabtest = require("./Tabtest.bs.js");
var Either$XodFuncTools = require("xod-func-tools/src/Either.bs.js");

function generatePatchSuite(project, patchPath) {
  return Either$XodFuncTools.fromResult(BeltHoles_Result.map(Tabtest$XodTabtest.generatePatchSuite(project, patchPath), (function (files) {
                    return Js_dict.fromList(Belt_MapString.toList(files));
                  })));
}

function generateProjectSuite(project) {
  return Either$XodFuncTools.fromResult(BeltHoles_Result.map(Tabtest$XodTabtest.generateProjectSuite(project), (function (files) {
                    return Js_dict.fromList(Belt_MapString.toList(files));
                  })));
}

exports.generatePatchSuite = generatePatchSuite;
exports.generateProjectSuite = generateProjectSuite;
/* Tabtest-XodTabtest Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-tabtest/src/Tabtest_Js.bs.js
// module id = 1465
// module chunks = 0